import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  useTheme,
  Theme,
} from "@mui/material";
import { StyledTableRow } from "../../../../../styles/Shipmentstyles";
import { InventorySwagpackVariant } from "../../../../../models/inventory/InventorySwagpackVariant";
import AppTableHeaderCell from "../../../../../views/components/common/pages/AppTableHeaderCell";
import CustomTypography from "../../../../../views/components/common/form/CustomTypography";

interface InventorySwagpackVariantTableProps {
  maxHeight: number;
  variants: InventorySwagpackVariant[];
  minHeight?: number;
}

const InventorySwagpackVariantTable = ({
  maxHeight,
  variants = [],
  minHeight = window.innerHeight - 350,
}: InventorySwagpackVariantTableProps) => {
  const theme = useTheme<Theme>();

  return (
    <TableContainer sx={{ maxHeight: maxHeight, minHeight: minHeight }}>
      <Table stickyHeader>
        <TableHead>
          <TableRow sx={{ width: "100%" }}>
            <AppTableHeaderCell  sx={{maxWidth: 150}} title=" VARIANT ID" fontSize="14px" />
            <AppTableHeaderCell title="PRODUCT NAME" fontSize="14px" />
            <AppTableHeaderCell title="COLOR" fontSize="14px" />
            <AppTableHeaderCell  sx={{maxWidth: 140}} title="SIZE" fontSize="14px" />
            <AppTableHeaderCell  title="CLIENT SKU" fontSize="14px" />
            <AppTableHeaderCell  sx={{maxWidth: 140}} title="QUANTITY" fontSize="14px" />
            <AppTableHeaderCell  sx={{maxWidth: 170}} title="INITIAL QUANTITY" fontSize="14px" />
            <AppTableHeaderCell  sx={{maxWidth: 170}} title="BLOCKED QUANTITY" fontSize="14px" />
            <AppTableHeaderCell  sx={{maxWidth: 170}} title="TOTAL QUANTITY" fontSize="14px" />
            <AppTableHeaderCell title="CREATED DATE" fontSize="14px" />
            <AppTableHeaderCell title="MODIFIED DATE" fontSize="14px" />
          </TableRow>
        </TableHead>

        <TableBody>
          {variants.map((variant) => (
            <StyledTableRow key={variant.id}>
              <TableCell
                sx={{
                  textAlign: "center",
                  fontSize: 14,
                }}
              >
                {variant.id}
              </TableCell>
              <TableCell sx={{ textAlign: "center", fontSize: 14 }}>
                {variant.product_name || "-"}
              </TableCell>
              <TableCell sx={{ textAlign: "center", fontSize: 14 }}>
                {variant.color || "-"}
              </TableCell>
              <TableCell sx={{ textAlign: "center", fontSize: 14 }}>
                {variant.size}
              </TableCell>
              <TableCell sx={{ textAlign: "center", fontSize: 14 }}>
                {variant.client_sku ?? "-"}
              </TableCell>
              <TableCell sx={{ textAlign: "center", fontSize: 14 }}>
                {variant.quantity ?? "-"}
              </TableCell>
              <TableCell sx={{ textAlign: "center", fontSize: 14 }}>
                {variant.initial_quantity ?? "-"}
              </TableCell>
              <TableCell sx={{ textAlign: "center", fontSize: 14 }}>
                {variant.blocked_quantity ?? "-"}
              </TableCell>
              <TableCell sx={{ textAlign: "center", fontSize: 14 }}>
                {variant.total_quantity ?? "-"}
              </TableCell>
              <TableCell sx={{ textAlign: "center", fontSize: 14 ,minWidth: 200}}>
                {variant.created_date
                  ? new Date(variant.created_date).toLocaleString()
                  : "-"}
              </TableCell>
              <TableCell sx={{ textAlign: "center", fontSize: 14 , minWidth: 200 }}>
                {variant.modified_date
                  ? new Date(variant.modified_date).toLocaleString()
                  : "-"}
              </TableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
      {variants.length === 0 && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            paddingTop: 15,
          }}
        >
          <CustomTypography
            color={theme.palette.customColors.greyTextColor}
            variant="body2"
            fontWeight={700}
          >
            NO VARIANT FOUND!
          </CustomTypography>
        </Box>
      )}
    </TableContainer>
  );
};

export default InventorySwagpackVariantTable;
